import React from 'react';

import { Typography, CardMedia, Box } from '@material-ui/core';
import ES from 'components/ExplainString';
import Experience from 'components/Experience';
import ProjectLink from 'components/ProjectLink';


import explains from 'data/explains'

import {Grid} from '@material-ui/core';

export default function gen(props){
  return (<Box>
    <Typography>
      On my leisure time, I like to explore new technology and apply them in projects. <br />
    </Typography>
    {/* Bullet Point */}
    <Typography component="div">
      <ul>
        <li>Picked up <ES {...explains['React']}>React</ES>, <ES {...explains['MUI']}>Material-Ui</ES> and <ES {...explains['ExpressJs']}>Express</ES> while making this portfolio <ProjectLink {...props} id='benshen98.github.io' /></li>
        <li>Learned <ES {...explains['Balena']}/> and <ES {...explains['DockerCompose']} />, used <ES {...explains['Alpine']}/> and <ES {...explains['Samba']} /> while building Smart Home Infrastructure on Raspberry Pi <ProjectLink {...props} id='smart_home'/></li>
        <li>Learned <ES {...explains['MQTT']} />, used <ES {...explains['HA']} /> and <ES {...explains['AD']} /> while automating my house <ProjectLink {...props} id='smart_home'/></li>
      </ul>
    </Typography>
  </Box>)
}
